<template>
  <b-dropdown id="language-switcher" no-caret right variant="main-body">
    <template #button-content>
      <span v-if="withLabel">{{ t(`locale:${locale}`) }}&nbsp; </span>
      <span :class="`fi fi-${normalizeIcon(locale)}`"></span>
      <span v-if="!withLabel" class="visually-hidden">{{ t(`locale:${locale}`) }}</span>
    </template>

    <b-dropdown-item
      v-for="(name, alpha2) of supportedLocales"
      :key="alpha2"
      @click="changeLocale(alpha2)"
    >
      <i :class="getClass(alpha2)"></i>
      {{ name }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts" setup>
import "flag-icons/css/flag-icons.min.css";
import { useLocale } from "@/composables/useLocale";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

interface Props {
  withLabel?: boolean;
}

withDefaults(defineProps<Props>(), {
  withLabel: false,
});

const { t } = useI18n();
const store = useStore();

const normalizeIcon = (locale: string) => {
  switch (locale) {
    case "en":
      return "gb";
    default:
      return locale;
  }
};

const getClass = (locale: string) => "fi fi-" + normalizeIcon(locale);

const { locale, changeLocale, supportedLocales } = useLocale(
  store.getters["auth/isAuthenticated"] ?? false,
);
</script>

<style>
.dropdown #language-switcher,
#language-switcher:first-child:active {
  border: 0px none !important;
}

#language-switcher .fi {
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
}
</style>
